var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicesImg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#020202;stroke-miterlimit:10;stroke-width:1.83px;}")), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.58 21.15 2.83 13.81 15.67 13.81 16.58 12.9 21.17 12.9 18.42 21.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.25,17.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.92,17.48h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.75,
    y1: 17.48,
    x2: 16.58,
    y2: 17.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.67 13.81 6.5 9.23 17.5 9.23 19.33 12.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.33,
    y: 5.56,
    width: 7.33,
    height: 3.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.17,
    y1: 1.9,
    x2: 10.17,
    y2: 5.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.83,
    y1: 1.9,
    x2: 13.83,
    y2: 5.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.25,
    y1: 11.98,
    x2: 9.25,
    y2: 13.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.92,
    y1: 11.98,
    x2: 12.92,
    y2: 13.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1,20.23H1a3.44,3.44,0,0,0,5.5,0h0a3.43,3.43,0,0,0,5.49,0h0a3.42,3.42,0,0,0,5.49,0h0a3.43,3.43,0,0,0,5.49,0h0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesImg1);
export default __webpack_public_path__ + "static/media/services_img_1.1b329875d89edf93cc6502095958359c.svg";
export { ForwardRef as ReactComponent };